import api, { learningRequestApi } from "./index";

export interface LearningRequestsListParamsV2 {
  ids?: Array<string>;
  number?: string;
  companyId?: string;
  responsibleId?: string;
  courseTitle?: string;
  categoryId?: string;
  contractorId?: string;
  contractorType?: "juridical" | "physical";
  formedAtMin?: Date;
  formedAtMax?: Date;
  courseIds?: Array<string>;
  profileIds?: Array<string>;
  statusIds?: Array<string>;
  studentIds?: Array<string>;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "number" | "formedAt" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: LearningRequestsListParamsV2) => {
  return learningRequestApi.Request.listRequests(
    params.ids,
    params.number,
    params.companyId,
    params.responsibleId,
    params.courseTitle,
    params.categoryId,
    params.contractorId,
    params.contractorType,
    params.formedAtMin,
    params.formedAtMax,
    params.courseIds,
    params.profileIds,
    params.statusIds,
    params.studentIds,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
